import React, { Component } from 'react';
import './categoryMobileMenu.scss';

/*-- Import required components --*/
import { productListingTypeEnum } from '../../utility/enums';

/*-- Imports for redux --*/
import { connect } from 'react-redux';
import { showAgeGate, resetAgeGate } from '../../redux/actions/ageGateActions';
import { showMessageBox, resetMessageBox } from '../../redux/actions/messageBoxActions';

/*-- Map the redux states to props --*/
function mapStateToProps(state) {
    return {
        webDataCollection: state.webDataCollection,
        ageVerification: state.ageVerification,
        systemConfiguration: state.webDataCollection.systemConfiguration
    }
};

/*-- Map the redux actions to props --*/
const mapDispatchToProps = {
    showAgeGate,
    resetAgeGate,
    showMessageBox,
    resetMessageBox
};

/**
 * Date     :   2020-06-23
 * Author   :   Dinushka Rukshan
 * Remarks  :   Mobile version of Category menu for select sub categories
 */
class CategoryMobileMenu extends Component {
    constructor(props) {
        super(props)

        this.state = {
            selectedDepartmentId: "",
            categoryMenuVisible: false,
            subCategoryMenuVisible: false
        }
    }

    closeMobileCategoryMenu() {
        this.toggleCategoryMenu();
    };

    toggleCategoryMenu() {
        if (!this.state.categoryMenuVisible) {
            document.getElementById("category_mobile_menu_default_header").style.left = 0;
            document.getElementById("category_mobile_menu_default_header").style.right = 0;
        } else {
            document.getElementById("category_mobile_menu_default_header").style.left = "-100%";
            document.getElementById("category_mobile_menu_default_header").style.right = "100%";
        }

        this.setState(prevState => ({
            categoryMenuVisible: !prevState.categoryMenuVisible,
        }));
    };

    renderMobileCategories() {
        let categoryMenu = [];
        const allDepartments = this.props.webDataCollection.departmentList;
        const allSubDepartments = this.props.webDataCollection.subDepartmentList;

        allDepartments.map((dep) => {

            categoryMenu.push(<li key={`dep_id_${dep.departmentID}`} id={`dep_id_${dep.departmentID}`} onClick={this.mobileCategoryChange.bind(this)}>{dep.departmentName} <span onClick={this.mobileCategoryChange.bind(this)}><i className="fa fa-angle-right"></i></span></li>);

            const subDepartments = allSubDepartments.filter(subDepartment => subDepartment.departmentID === dep.departmentID);
            let subCategoryMenu = [];subCategoryMenu.push(<a key={dep.departmentID} onClick={this.gotoDepartment.bind(this, dep.checkAge, `/${dep.url}`)}><li className="cat_item_" data-cat-id="all"><strong>{`All ${dep.departmentName}`}</strong></li></a>);
            subDepartments.map((subDep) => {
                subCategoryMenu.push(<a key={subDep.subDepartmentID} onClick={this.gotoDepartment.bind(this, subDep.checkAge, `/${subDep.url}`)}><li>{subDep.subDepartmentName}</li></a>);
            });
            categoryMenu.push(<ul key={`sub_dep_id_${dep.departmentID}`} id={`sub_dep_id_${dep.departmentID}`} style={{ display: "none" }}>{subCategoryMenu}</ul>);
        });

        return categoryMenu;
    };

    mobileCategoryChange = (event) => {
        const departmentId = event.target.id;
        if (this.state.selectedDepartmentId != "") {
            const subDepartmentId = "sub_dep_id_" + this.state.selectedDepartmentId.split('dep_id_')[1];
            document.getElementById(subDepartmentId).style.display = "none";
            document.getElementById(this.state.selectedDepartmentId).classList.remove('active');
        }

        if (departmentId) {
            this.setState({
                selectedDepartmentId: departmentId,
                subCategoryMenuVisible: true
            }, () => {
                const subDepartmentId = "sub_dep_id_" + departmentId.split('dep_id_')[1];
                document.getElementById(subDepartmentId).style.display = "block";
                document.getElementById(departmentId).classList.add('active');
            });
        }
    };

    gotoDepartment(checkAge, data) {
        if (checkAge) {
            if (this.props.ageVerification.isLegalAge && this.props.ageVerification.attemptedVerification) {
                window.location.href = data;
            } else if (!this.props.ageVerification.isLegalAge && this.props.ageVerification.attemptedVerification) {
                this.showAgeFail();
            } else if (!this.props.ageVerification.attemptedVerification) {
                let ageGate = {
                    show: true,
                    isPage: true,
                    callBackFunction: (response) => {
                        if (response) {
                            this.props.resetAgeGate().then(() => { window.location.href = data; })
                        } else {
                            this.props.resetAgeGate()
                            this.showAgeFail();
                        }
                    }
                }
                this.props.showAgeGate(ageGate);
            }
        } else {
            window.location.href = data;
        }

    }

    showAgeFail() {
        let messageBox = {
            show: true,
            title: "Information",
            className: "info",
            content: "You must be " + this.props.systemConfiguration.legalAgeLimit + " years or older to enter the Liquor and/or tobacco page on our site.",
            isConfirmation: false,
            callBackFunction: null
        }
        this.props.showMessageBox(messageBox);
    }

    render() {
        return (
            <div id="category_mobile_menu_default_header">
                <div className="row category-header">
                    <h4 className="header-text mb-0">All Departments</h4>
                    <div className="cat-mob-menu-close" onClick={() => this.closeMobileCategoryMenu()}>
                        <i className="fa fa-times"></i>
                    </div>
                </div>
                <div className="cat-mob-menu-container-default-header">
                    <ul className="cat-mob-menu-area">
                        {
                            this.renderMobileCategories()
                        }
                    </ul>
                </div>
            </div>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(CategoryMobileMenu);
